// extracted by mini-css-extract-plugin
module.exports = {"root":"AssignSquads_root__W8YXA","tableControls":"AssignSquads_tableControls__mrna8","search":"AssignSquads_search__4NRcY"};